import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { StarIcon, QuoteIcon } from 'lucide-react';
type Testimonial = {
  id: number;
  name: string;
  role: string;
  content: string;
  rating: number;
  program: string;
  avatar: string;
};
const testimonials: Testimonial[] = [{
  id: 1,
  name: 'Bartosz Krawczyk',
  role: 'Trader indywidualny',
  content: 'Program Apex Convergence całkowicie zmienił moje podejście do analizy. Formacje harmoniczne, które wcześniej wydawały się abstrakcyjne, teraz widzę na wykresach naturalnie.',
  rating: 5,
  program: 'Apex Convergence',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face'
}, {
  id: 2,
  name: 'Magdalena Wiśniewska',
  role: 'Analityk finansowy',
  content: 'Jako osoba z doświadczeniem w finansach, szukałam czegoś więcej niż podstawy. Cipher Matrix dał mi narzędzia do automatyzacji moich strategii.',
  rating: 5,
  program: 'Cipher Matrix',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face'
}, {
  id: 3,
  name: 'Tomasz Nowicki',
  role: 'Przedsiębiorca',
  content: 'Zaczynałem od zera. Meridian Protocol dał mi solidne fundamenty. Po 6 miesiącach czuję się pewnie analizując wykresy i podejmując decyzje.',
  rating: 5,
  program: 'Meridian Protocol',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face'
}, {
  id: 4,
  name: 'Karolina Dąbrowska',
  role: 'Portfolio Manager',
  content: 'Zenith Mastery to inwestycja, która się zwróciła wielokrotnie. Sesje 1:1 z mentorem były bezcenne dla mojego rozwoju.',
  rating: 5,
  program: 'Zenith Mastery',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face'
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-gray-950" data-id="element-234">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-235">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-236">
          <motion.span initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-emerald-400 text-sm font-medium tracking-wider uppercase" data-id="element-237">
            Opinie uczestników
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl sm:text-4xl font-bold text-white mt-4 mb-4" data-id="element-238">
            Co mówią nasi absolwenci
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-gray-400 max-w-2xl mx-auto" data-id="element-239">
            Dołącz do społeczności traderów, którzy rozwinęli swoje umiejętności
            z Winrealm.
          </motion.p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-240">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-241">
              <Card className="p-6 h-full" data-id="element-242">
                {/* Quote Icon */}
                <QuoteIcon className="w-8 h-8 text-emerald-500/30 mb-4" data-id="element-243" />

                {/* Content */}
                <p className="text-gray-300 mb-6 leading-relaxed" data-id="element-244">
                  "{testimonial.content}"
                </p>

                {/* Rating */}
                <div className="flex items-center gap-1 mb-4" data-id="element-245">
                  {Array.from({
                length: testimonial.rating
              }).map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-246" />)}
                </div>

                {/* Author */}
                <div className="flex items-center gap-4 pt-4 border-t border-gray-800" data-id="element-247">
                  <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover" data-id="element-248" />
                  <div data-id="element-249">
                    <div className="font-semibold text-white" data-id="element-250">
                      {testimonial.name}
                    </div>
                    <div className="text-sm text-gray-500" data-id="element-251">
                      {testimonial.role}
                    </div>
                  </div>
                  <div className="ml-auto" data-id="element-252">
                    <span className="text-xs text-emerald-400 bg-emerald-500/10 px-2 py-1 rounded-full" data-id="element-253">
                      {testimonial.program}
                    </span>
                  </div>
                </div>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}